export default __webpack_public_path__ + "static/media/5092.6d32d444.png";